export const NOTIFICATION_CODE = {
    602: 'POPUP',
    // 601: 'CALL',
    600: 'PUSH',
    // 603: 'SMS',
    // 604: 'EMAIL'
}